import dayjs from "dayjs";

export const isCardExpired = (cardExpiry) => {
  if (!cardExpiry) return false;
  const [month, year] = cardExpiry.split("/");
  const expiryDate = dayjs(`20${year}-${month}-01`).endOf("month");
  return dayjs().isAfter(expiryDate);
};

export const getCardExpiryStatus = (cardExpiry) => {
  if (!cardExpiry) return null;

  const [month, year] = cardExpiry.split("/");
  const expiryDate = dayjs(`20${year}-${month}-01`).endOf("month");
  const today = dayjs();
  const monthsUntilExpiry = expiryDate.diff(today, "month");

  if (today.isAfter(expiryDate)) {
    return { status: "expired", text: "만료됨", color: "red" };
  }
  if (monthsUntilExpiry <= 1) {
    return { status: "expiring_soon", text: "1개월 내 만료", color: "orange" };
  }
  if (monthsUntilExpiry <= 3) {
    return { status: "expiring_soon", text: "3개월 내 만료", color: "gold" };
  }
  return { status: "valid", text: "유효", color: "green" };
};
